/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

import Vue from 'vue';

import datetimeFilter from '@/filters/Datetime';
import nl2br from '@/filters/Nl2Br';
import linkify from '@/filters/Linkify';

/**
 * Filter initialisation module.
 *
 * Adds filters into Vue instance.
 *
 * @author Jonny Cook <jcook@frontier.co.uk>
 */

Vue.filter('datetime', datetimeFilter);
Vue.filter('nl2br', nl2br);
Vue.filter('linkify', linkify);
